const catalogos = [{
    name: 'profesiones',
    url: 'professions'
}, {
    name: 'bancos',
    url: 'banks'
}, {
    name: 'categorias',
    url: 'categories'
}, {
    name: 'forma-pago',
    url: 'billPaymentMethods'
}, {
    name: 'tipo-pago',
    url: 'billPaymentTypes'
}];

const estadoGeneric = {
    elaborado: 1,
    anulado: 2
}

export const estadoSalida = { ...estadoGeneric };

export const estadoEntrada = { ...estadoGeneric };

export const estadoServicio = { ...estadoGeneric };

export const estadoCompra = { ...estadoGeneric };

export const etapaCompra = { ...estadoGeneric, ... { recibida: 2 } };

export const formaPago = { contado: 1, credito: 2 }

export const tipoMovimiento = { entrada: 1, salida: 2 }

export const monedaSymbol = {
    1: "C$",
    2: "$"
}

export const tipoArticulos = { LentesOftalmicos: 1, LentesDeContacto: 2, MarcoAro: 3, Mantenimiento: 4,Accesorios:5,LentesEsclerales:6 };

export const catalogosConocidos = {
    MarcaLenteOftalmico: 'MarcaLenteOftalmico',
    ModeloLenteOftalmico: 'ModeloLenteOftalmico',
    MarcaLenteContacto:'MarcaLenteContacto',
    ModeloLenteContacto:'ModeloLenteContacto',
    TipoLente: 'TipoLente',
    SubTipoLente: 'SubTipoLente',
    TipoLenteContacto:'TipoLenteContacto',
    Material: 'Material',
    Tratamiento: 'Tratamiento',
    Color: 'Color',
    AlturaMarco:'AlturaMarco',
    SubTipoMantenimiento:'SubTipoMantenimiento',
    TipoMarco:'TipoMarco',
    AlturaMarco:'AlturaMarco',
    MarcaMarcoAro:'MarcaMarcoAro',
    ModeloMarcoAro:'ModeloMarcoAro',
    MarcaAccesorio:'MarcaAccesorio',
    MarcaLentesEsclerales:'MarcaLentesEsclerales',
    ModeloLentesEsclerales:'ModeloLentesEsclerales',
    TipoLentesEsclerales:'TipoLentesEsclerales',
    DisenoLenteEsclerales:'DiseñoLenteEsclerales',
};

export const catalogoValores={
    TipoLente:{
        Bifocal:69,
        Progresivo:70
    },
    Tratamiento:{
        Color:87
    }
}

export default catalogos;